<template>
    <div class="d-inline-block">
        <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list class="py-0">
                <div class="subtitle-2 mx-5 pt-5 pb-3">Administrator Aktionen</div>
                <span v-if='user.permissions.ergebnisdienst'>
                    <v-list-item v-for="(item, i) in itemsAdmin" :key="i"
                                 @click="requestActionConfirm(item)"
                                 :disabled="item.disabled">
                        <v-list-item-icon class="mr-2">
                            <v-icon>mdi-file-document-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </span>
                <v-list-item v-for="(item, i) in items" :key="i"
                             @click="requestActionConfirm(item)"
                             :disabled="item.disabled">
                    <v-list-item-icon class="mr-2">
                        <v-icon>mdi-file-document-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="user.permissions.ergebnisdienst"
                             :disabled="!user.permissions.ergebnisdienst ||
                                        spiel.vereine.heim.indexOf('pending') !== -1"
                             @click="adminEditMaL()">
                    <v-list-item-icon class="mr-2">
                        <v-icon>mdi-account-group</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Mannschaftsaufstellung ändern</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="user.permissions.ergebnisdienst"
                             :disabled="!user.permissions.ergebnisdienst ||
                                        spiel.vereine.heim.indexOf('pending') !== -1"
                             @click="adminEditSpielbericht()">
                    <v-list-item-icon class="mr-2">
                        <v-icon>mdi-table-large</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Spielbericht ändern</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <confirm-dialog :open="confirmAction.open" :header="confirmAction.header"
                        :question="confirmAction.question" :queryParameter="spiel.id"
                        @reply="processConfirm" >
        </confirm-dialog>
        <spiel-berichte-protest-aendern :spiel="spielFull">
        </spiel-berichte-protest-aendern>
        <spiel-berichte-strafverifizierung :spiel="spielFull">
        </spiel-berichte-strafverifizierung>
    </div>
</template>

<script>
    import {db} from "../../../services/db";
    import {firestore} from "../../../services/db";
    import SpielService from "../../../services/data/spielService";
    import ConfirmDialog from "../../../components/navigation/confirmDialog";
    import {Spiel} from "../../../services/data/spiel";
    import SpielBerichteStrafverifizierung from "./spielBerichteStrafverifizierung";
    import SpielBerichteProtestAendern from "./spielBerichteProtestAendern";

    export default {
        components: {
            SpielBerichteProtestAendern,
            SpielBerichteStrafverifizierung,
            ConfirmDialog},
        name: "spiel-berichte-admin-menu",
        props: ['spiel', 'saison'],
        data: () => ({
            confirmAction: {
                open: false,
                question: '',
                item: null,
            },
            spielFull: null,
        }),
        computed: {
            user(){ return this.$store.state.user; },
            itemsAdmin(){
                return [{ title: 'MaL leeren',
                            action: 'adminEmptyMaL',
                            question: 'Möchtest du wirklich die Mannschaftsaufstellung leeren?',
                            success: 'Die Mannschaftsaufstellung wurde erfolgreich geleert!',
                            disabled: this.spiel.heim.result.kegel > 0 ||
                            this.spiel.gast.result.kegel > 0 ||
                            !this.spiel.referee.name ||
                            !this.user.permissions.ergebnisdienst},
                    { title: 'Spielbericht leeren',
                        action: 'adminEmptySpielbericht',
                        question: 'Möchtest du wirklich den Spielbericht leeren?',
                        success: 'Der Spielbericht wurde erfolgreich geleert!',
                        disabled: this.spiel.heim.result.kegel + this.spiel.gast.result.kegel === 0 ||
                        this.spiel.vereine.heim.indexOf('pending') === -1 ||
                        !this.user.permissions.ergebnisdienst},
                ];
            },
            items(){
                return [
                        { title: 'Heim Bestätigung rücksetzen',
                            action: 'adminCancelHeimConfirm',
                            question: 'Möchtest du wirklich die Bestätigung der ' +
                                      'Heimmannschaft zurücksetzen?',
                            success: 'Die Bestätigung durch die Heimmannschaft wurde zurückgesetzt!',
                            disabled: this.spiel.vereine.heim.indexOf('created') === -1 },
                        { title: 'Gast Bestätigung rücksetzen',
                            action: 'adminCancelGastConfirm',
                            question: 'Möchtest du wirklich die Bestätigung der ' +
                                    'Gastmannschaft zurücksetzen?',
                            success: 'Die Bestätigung durch die Gastmannschaft wurde zurückgesetzt!',
                            disabled: this.spiel.vereine.gast.indexOf('confirmed') === -1 &&
                                      this.spiel.vereine.gast.indexOf('rejected') === -1 },
                        { title: 'Protest ändern',
                            action: 'adminProtest',
                            success: 'Der Protest im Spiel wurde erfolgreich geändert!',
                            disabled: false },
                        { title: 'Strafverifizierung',
                            action: 'adminStrafverifizierung',
                            success: 'Das Spiel wurde erfolgreich strafverifiziert!',
                            disabled: false },
                        { title: 'Endgültig Löschen',
                            action: 'deleteFinal',
                            question: 'Möchtest du dieses Spiel wirklich endgültig und unwiderruflich ' +
                                    'löschen?',
                            success: 'Das Spiel wurde erfolgreich gelöscht!',
                            disabled: !this.user.permissions.ergebnisdienst },
                       ];
            },
        },
        methods: {
            requestActionConfirm(item){
                if ( item.action !== 'adminStrafverifizierung' &&
                     item.action !== 'adminProtest' ) {
                    this.confirmAction.item = item;
                    this.confirmAction.question = item.question;
                    this.confirmAction.open = true;
                } else if ( item.action === 'adminStrafverifizierung' ) {
                    this.openStrafverifizierung();
                } else if ( item.action === 'adminProtest' )  {
                    this.openProtest();
                }
            },
            processConfirm(reply) {
                let updateDocument = null;
                if ( reply ) {
                    switch (this.confirmAction.item.action) {
                        case 'adminEmptyMaL':
                            this.getAndEditFullSpiel('adminEmptyMaL');
                            break;
                        case 'adminEmptySpielbericht':
                            this.getAndEditFullSpiel('adminEmptySpielbericht');
                            break;
                        case 'adminCancelHeimConfirm':
                            updateDocument = SpielService.adminCancelHeimConfirm(this.spiel);
                            this.updateInDB(updateDocument);
                            this.updateSaisonSchnittliste();
                            break;
                        case 'adminCancelGastConfirm':
                            updateDocument = SpielService.adminCancelGastConfirm(this.spiel);
                            this.updateInDB(updateDocument);
                            break;
                        case 'deleteFinal':
                            this.deleteInDB(updateDocument);
                            break;
                    }
                }
                this.confirmAction.open = false;
            },
            updateInDB(updateDocument){
                db.collection("spiele").doc(this.spiel.id).update(updateDocument)
                    .then(() => {
                        this.showSnack(true, this.confirmAction.item.success);
                        console.log("Document successfully updated!");
                    })
                    .catch((error) => {
                        this.showSnack(false, '');
                        console.error("Error updating document: ", error);
                    });
            },
            deleteInDB(){
                db.collection("spiele").doc(this.spiel.id).delete()
                .then(() => {
                    this.updateSaison();
                    this.updateSaisonSchnittliste();
                    console.log("Document successfully deleted!");
                }).catch((error) => {
                    this.showSnack(false, '');
                    console.error("Error removing document: ", error);
                });
            },
                async updateSaison(){
                    this.saison.local.documentUpdates = {
                        ['spiele.' + this.spiel.id]: firestore.FieldValue.delete()
                    };
                    await this.saison.saveEdited('saison_edit');
                    this.showSnack(true, this.confirmAction.item.success);
                    this.saison.local.documentUpdates = {};
                },
                async updateSaisonSchnittliste(){
                    if ( this.spiel.saison.isCup ) return
                    db.collection('saisonen/' + this.saison.id + '/schnittliste')
                        .doc(this.spiel.saison.id + this.spiel.saison.semester).update({
                            ['spiele.' + this.spiel.id]: firestore.FieldValue.delete()
                        })
                        .then(() => {
                            console.log("Document successfully updated!");
                        })
                        .catch((error) => {
                            this.showSnack(false, '');
                            console.error("Error updating document: ", error);
                        });
                },
            getAndEditFullSpiel(type){
                db.collection("spiele").doc(this.spiel.id).get()
                    .then((doc) => {
                        if (doc.exists) {
                            let spielTemp = doc.data();
                            spielTemp.id = doc.id;
                            let spiel = new Spiel();
                            spiel.setFromDataObject(spielTemp);
                            const updateDocument = type === 'adminEmptySpielbericht' ?
                                                    SpielService.adminEmptySpielbericht(spiel) :
                                                    SpielService.adminEmptyMaL(spiel);
                            this.updateInDB(updateDocument);
                            this.showSnack(true, this.confirmAction.item.success);
                        } else {
                            console.log("No such document!");
                            this.showSnack(false, '');
                        }
                    })
                    .catch((error) => {
                        this.showSnack(false, '');
                        console.log("Error getting document:", error);
                    });
            },
            showSnack(success, text){
                this.$store.dispatch('clearSnackbar');
                this.$store.state.globalSnack.timeout = 4000;
                if ( !success ) {
                    this.$store.state.globalSnack.color = 'error';
                    this.$store.state.globalSnack.text = 'Die Aktion konnte nicht abgeschlossen werden, ' +
                        'es ist ein Fehler aufgetreten!';
                } else {
                    this.$store.state.globalSnack.color = 'success';
                    this.$store.state.globalSnack.text = text;
                }
                this.$store.state.globalSnack.show = true;
            },
            openStrafverifizierung(){
                db.collection("spiele").doc(this.spiel.id).get()
                    .then((doc) => {
                        if (doc.exists) {
                            this.spielFull = doc.data();
                            this.spielFull.id = doc.id;
                            let p = JSON.parse(JSON.stringify(this.$route.path));
                            let q = JSON.parse(JSON.stringify(this.$route.query));
                            q.action = 'strafverifizieren' + this.spiel.id;
                            this.$router.push({path: p, query: q});
                        } else {
                            console.log("No such document!");
                            this.showSnack(false, '');
                        }
                    })
                    .catch((error) => {
                        this.showSnack(false, '');
                        console.log("Error getting document:", error);
                    });
            },
            openProtest(){
                db.collection("spiele").doc(this.spiel.id).get()
                    .then((doc) => {
                        if (doc.exists) {
                            this.spielFull = doc.data();
                            this.spielFull.id = doc.id;
                            let p = JSON.parse(JSON.stringify(this.$route.path));
                            let q = JSON.parse(JSON.stringify(this.$route.query));
                            q.action = 'protestAendern' + this.spiel.id;
                            this.$router.push({path: p, query: q});
                        } else {
                            console.log("No such document!");
                            this.showSnack(false, '');
                        }
                    })
                    .catch((error) => {
                        this.showSnack(false, '');
                        console.log("Error getting document:", error);
                    });
            },
            adminEditSpielbericht(){
                this.$emit('adminEditSpielbericht', this.spiel);
            },
            adminEditMaL(){
                this.$emit('adminEditMaL', this.spiel);
            }
        },

    }
</script>

<style scoped>

</style>